import { SafetyInspectionResult } from "../../../amorg-common";
import { uploadInspectionPointImage, deleteInspectionPointImage } from "../../../api/safetyInspectionClientApi";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { FileUploadButton } from "../../../designSystem/formField/FileUploadButton";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import React from "react";
import { ThumbnailImageGallery } from "../../../designSystem/ThumbnailImageGallery";

type InspectionImagesPanelProps = {
    inspection:SafetyInspectionResult,
    onUpdated:()=>void
}
export function InspectionImagesPanel(props:InspectionImagesPanelProps):JSX.Element
{
    const [loading, setLoading] = React.useState(false);

    async function handleClickUpload(file:File)
    {
        setLoading(true);
        const result = await uploadInspectionPointImage(props.inspection.id, file);
        if(result.isSuccess){
            props.onUpdated();
        }
        setLoading(false);
    }

    async function handleDeleteFile(privateFileName:string)
    {
        setLoading(true);
        await deleteInspectionPointImage(props.inspection.id, privateFileName);
        setLoading(false);

        props.onUpdated();
    }

    return (
        <div>
            <LoadingPageOverlay loading={loading} />
            <Flex flexDirection='column' gap={16}>

                <Flex flexDirection="column" alignItems='center'>
                    <FileUploadButton
                        inputName='uploaded_file'
                        fileTypes={['jpg','txt']}
                        magnum
                        text="Upload fil"
                        onClickUpload={handleClickUpload} />
                </Flex>

                <ThumbnailImageGallery files={props.inspection.files} onDelete={handleDeleteFile} />
                

            </Flex>
        </div>
    );
}